import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const FeaturesSection = () => {
  const { language } = useLanguage();

  const features = [
    {
      icon: "bi-person-plus-fill",
      titleKey: "features.admissionManagement",
      descKey: "features.admissionDesc"
    },
    // {
    //   icon: "bi-people-fill",
    //   titleKey: "features.admissionManagement",
    //   descKey: "features.admissionDesc"
    // },
    {
      icon: "bi-calendar-check-fill",
      titleKey: "features.attendanceTracking",
      descKey: "features.attendanceDesc"
    },
    {
      icon: "bi-file-earmark-text-fill",
      titleKey: "features.examManagement",
      descKey: "features.examDesc"
    },
    // {
    //   icon: "bi-clock-fill",
    //   titleKey: "features.admissionManagement",
    //   descKey: "features.admissionDesc"
    // },
    // {
    //   icon: "bi-person-badge-fill",
    //   titleKey: "features.admissionManagement",
    //   descKey: "features.admissionDesc"
    // },
    {
      icon: "bi-cash-stack",
      titleKey: "features.feeManagement",
      descKey: "features.feeDesc"
    },
    {
      icon: "bi-book-fill",
      titleKey: "features.reportGeneration",
      descKey: "features.reportDesc"
    },
    {
      icon: "bi-phone-fill",
      titleKey: "features.parentPortal",
      descKey: "features.parentDesc"
    }
  ];

  return (
    <section className="section-padding" id="features">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'features.title')}</h2>
          <p>
            {getTranslation(language, 'features.subtitle')}
          </p>
        </div>
        
        <div className="row g-4">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={index * 50}
            >
              <div className="feature-card">
                <div className="feature-icon">
                  <i className={`bi ${feature.icon}`}></i>
                </div>
                <h5>{getTranslation(language, feature.titleKey)}</h5>
                <p>{getTranslation(language, feature.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
